import { RouteObject } from 'react-router-dom'
import ClienteDetailPage from '@/pages/clientes/ClienteDetailPage'
import ClienteFormPage from '@/pages/clientes/ClienteFormPage'
import { SomenteBackoffice } from '../SomenteBackoffice'

/**
 * Rotas da Onda 1 da Visão do Consultor (DEV-4, VC-08 — resíduos da !134).
 *
 * Detalhe e edição de cliente saíram de `router/index.tsx` para cá: desde 23/10
 * Operações e Clientes é só do back-office (menu e `/operacoes-clientes`), mas
 * `clientes/:id` e `clientes/:id/editar` ainda abriam para o consultor pela URL.
 * Agora passam pelo mesmo guarda (`SomenteBackoffice`): o consultor volta ao dashboard.
 *
 * Não há rota de criação: todo cliente nasce de uma reserva convertida (Jornada do
 * Consultor, Etapa 21) — criar à mão geraria cliente sem origem nem carteira.
 */
const rotasVcDev4: RouteObject[] = [
  {
    path: 'clientes/:id',
    element: (
      <SomenteBackoffice>
        <ClienteDetailPage />
      </SomenteBackoffice>
    ),
  },
  {
    path: 'clientes/:id/editar',
    element: (
      <SomenteBackoffice>
        <ClienteFormPage />
      </SomenteBackoffice>
    ),
  },
]

export default rotasVcDev4
